import React from 'react';
import { render } from 'react-dom';
import { Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { StoreContext } from 'redux-react-hook';
import { persistStore } from 'redux-persist';
import localForage from 'localforage';
import createBrowserHistory from 'history/createBrowserHistory';
import { BrowserView, MobileView } from 'react-device-detect';

import App from './layout/App';
import store from './redux/store';
import AppMobile from './layout/components/AppMobile/AppMobile';

export const history = createBrowserHistory();

export const persist = persistStore(
  store,
  {
    storage: localForage,
    whitelist: ['auth', 'setting'],
  },
  () => {
    render(
      <Provider store={store}>
        <Router history={history}>
          <StoreContext.Provider value={store}>
            <BrowserView>
              <App />
            </BrowserView>
            <MobileView>
              <AppMobile />
            </MobileView>
          </StoreContext.Provider>
        </Router>
      </Provider>,
      document.getElementById('app'),
    );
  },
);



// WEBPACK FOOTER //
// ./foody/src/index.js